import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getDataQualityDashboard,
  getDataQualityErrorsByCategory,
} from '../../services/dataQuality.service';
import { DataQualityDashboardModel } from '../../types/DataQualityDashboardModel';
import {
  DataQualityDashboardRequest,
  DataQualityErrorsRequest,
} from '../../types/DataQualityDashboardRequest';
import { DataQualityErrorList } from '../../types/DataQualityErrorList';

export const fetchDataQualityData = createAsyncThunk(
  'dataQuality/fetchDataQualityData',
  async (params: DataQualityDashboardRequest, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<DataQualityDashboardModel>(
      thunkAPI,
      getDataQualityDashboard(params, { signal: thunkAPI.signal })
    );
  }
);

export const fetchDataQualityItemsForCategory = createAsyncThunk(
  'dataQuality/fetchDataQualityItemsForCategory',
  async (params: DataQualityErrorsRequest, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<DataQualityErrorList>(
      thunkAPI,
      getDataQualityErrorsByCategory(params, { signal: thunkAPI.signal })
    );
  }
);
